import { Flex, Img, Text, Button } from "@chakra-ui/react";
import { useSelector } from "react-redux";

const ConfirmProductCreation = ({ product, onConfirm, onCancel, loading }) => {
  const storesData = useSelector((state) => state.storesList);

  const getStoreNameOrNull = (storeId) => {
    const store = storesData.stores.find((store) => store._id === storeId);
    return store ? store.name : null;
  };

  const { description, name, image, price, store, stock } = product;
  return (
    <Flex flexDir="column">
      <Flex>
        <Flex flex={1} direction="column">
          <Flex>
            Nombre:{" "}
            <Text ml=".3em" fontWeight="bold">
              {name}
            </Text>
          </Flex>
          <Flex>
            Descripción:{" "}
            <Text ml=".3em" fontWeight="bold">
              {description}
            </Text>
          </Flex>
          <Flex>
            Precio:{" "}
            <Text ml=".3em" fontWeight="bold">
              ${price}
            </Text>
          </Flex>
          <Flex>
            Tienda:{" "}
            <Text ml=".3em" fontWeight="bold">
              {
                getStoreNameOrNull(store)
              }
            </Text>
          </Flex>
          <Flex>
            Stock:{" "}
            <Text ml=".3em" fontWeight="bold">
              {stock}
            </Text>
          </Flex>
        </Flex>
        <Flex flex={1} justifyContent="center" alignItems="center">
          <Img
            src={image ? image : "https://via.placeholder.com/150"}
            alt="product"
            w="150px"
            h="150px"
            objectFit="cover"
          />
        </Flex>
      </Flex>
      <Flex w='100%' py='20px' justifyContent='center'>
        <Button 
            variant='ghost'
            onClick={onCancel}
            disabled={loading}
        >
            <Text color='gray.500'>Cancelar</Text>
        </Button>
        <Button ml='.5em'
            onClick={onConfirm}
            disabled={loading}
            isLoading={loading}
        >
            <Text>Confirmar</Text>
        </Button>
      </Flex>
    </Flex>
  );
};

export default ConfirmProductCreation;
